'use strict';

import { dataMember, required } from 'santee-dcts';

export class StudyGroupInfo {

    @dataMember()
    @required()
    public groupPk: number;

    @dataMember()
    @required()
    public groupName: string;

    @dataMember()
    @required()
    public studyList: StudyInfo[];

    public cardStudyList: StudyInfo[];

    @dataMember()
    public createdDate: string;

    @dataMember()
    public updatedDate: string;

    @dataMember()
    public sponsorName: string;

    public cardGroupName: string;

    constructor() {
        this.studyList = [];
        this.cardStudyList = [];
    }

}


export class StudyInfo {
    @dataMember()
    @required()
    public protocolPk: number;

    @dataMember()
    @required()
    public protocolCode: string;

    public cardProtocolCode: string;

    public sponsorName: string;

    @dataMember()
    @required({ nullable: true })
    public isActive: boolean;
}

export class SampleTrackerData {
    @dataMember()
    public studyId: number;

    @dataMember()
    public userPk: number;

    @dataMember()
    public studyGroupName: string;

    @dataMember()
    public studyGroupId: number[] = [];

    @dataMember()
    public protocolFk: number;

    @dataMember()
    public protocolCode: string;

    @dataMember()
    public sponsorName: string;

    @dataMember()
    public siteLinkUserId: string;

    public cardProtocolCode: string;

    public key: number;

    public value: string;

    public isChecked = false;

}

export class ActionButtonOption {
    public text: string;
    public isRouteToDashboard: boolean;
}